import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  QueryParams,
  QueryParamsService,
} from "common";
import { ActivatedRoute, Router } from "@angular/router";
import { FacilitiesFacade } from "../../domain/+state/facilities-facade";
import { FacilityListFacade } from "./facility-list.facade";
import { FacilityListInputData, FacilitiesIsDefaultLabel, FacilitiesActiveLabel } from "../../domain/models/facility.model";
import { routerTransition } from "../../../../shared/animations/router.animations";
import { readWrite } from "../../../../user/user-permission/user-permission.data";
import { UserPermissionService } from "../../../../user/user-permission/user-permission.service";

@UntilDestroy()
@Component({
    selector: "ifb-facility-list",
    templateUrl: "./facility-list.component.html",
    styleUrls: ["./facility-list.component.scss"],
    providers: [FacilityListFacade],
    animations: routerTransition,
    standalone: false
})
export class FacilityListComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  
  private queryParams: QueryParams;

  readWriteFacilities: boolean;
  data: FacilityListInputData = {
    dataSource: {
      totalCount: 0,
      values: [],
    },
    isWriteAllowed: false,
    filterData: undefined,
  };

  readonly FacilitiesIsDefaultLabel = FacilitiesIsDefaultLabel;
  readonly FacilitiesActiveLabel = FacilitiesActiveLabel;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly queryParamsService: QueryParamsService,
    private readonly userPermissionService: UserPermissionService,
    private readonly facilitiesFacade: FacilitiesFacade,
    private readonly facilityListFacade: FacilityListFacade,
    private readonly router: Router
  ) {}

  tableColumns = [
    "facilityName",
    "isDefault",
    "allowedProducts",
    "maximumAcceptableLoanCreditLimit",
    "borrowingCapacity",
    "active",
    "outboundBankAccount",
    "inboundBankAccount",
    "actions"
  ];

  ngOnInit(): void {
    this.userPermissionService
      .granted([readWrite("admin-facilities")])
      .pipe(untilDestroyed(this))
      .subscribe((res) => (this.readWriteFacilities = res));

    this.route.queryParams.pipe(untilDestroyed(this)).subscribe((it) => {
      this.queryParams = {
        ...this.queryParamsService.init(it),
      };

      this.refreshFacilities();
    });
  }

  private refreshFacilities() : void {
    const queryParams: QueryParams = {
      limit: this.queryParams.limit,
      skip: this.queryParams.skip,
      sort: this.queryParams.sort,
    };

    this.facilitiesFacade.getFacilities(queryParams).subscribe((res) => {
      this.data = {
        dataSource: res,
        isWriteAllowed: this.readWriteFacilities,
        filterData: this.queryParams
      };

      this.paginator.pageSize = this.data?.filterData?.limit;
      this.paginator.pageIndex =
        this.data?.filterData?.skip / this.data?.filterData?.limit;
    });
  }

  onFilter() : void {
    this.facilityListFacade.filter(this.paginator);
  }

  onEdit(id: number) : void {
    this.router.navigate([`/admin/facilities/${id}`]);
  }  
}
